import React from "react";
import { Link } from "react-router-dom";
const Associate = () => {
  return (
    <div className="Associate__container">
      <div className="box">
        <h1>
          CoinStorey Associates - coinstorey referral and affiliate marketing
          program
        </h1>
        <p>
          Welcome to the world's first cryptocurrency referral and affiliate
          marketing programs in the world. The CoinStorey Associates Program
          helps content creators, publishers and bloggers monetize their
          traffic. associates use easy link-building tools to direct their
          audience to their recommendations, and earn from action made by their
          audience.
        </p>
        <h1>Become A CoinStorey Associates NOW.</h1>
        <p>
          Join thousands of creators, publishers and bloggers who are earning
          with the CoinStorey Associates Program.
        </p>

        <h3>How does it work?</h3>
        <h3>Get your link</h3>
        <p>
          Join CoinStorey and get your unique associate link. You’ll earn for
          customers who sign up through this link.
        </p>
        <h3>Share you link</h3>
        <p>
          Share your associate link via email, whatsapp, twitter, facebook or
          anyway you want. The more you promote,the more you earn.
        </p>
        <h3>Earn when they play!</h3>
        <p>
          You can earn exactly 50% of a company's Profit from every friend you
          share.
        </p>
        <h3>Launch Competitions</h3>
        <p>
          Start earning exactly 15% of the company's profit everytime you create
          your contest of 40+ participants.
        </p>

        <Link to="/associate/terms-and-conditions">
          <p>
            Click here to view terms and conditions of coinstorey Associate
            Program
          </p>
        </Link>
        <p>
          © 2018-{new Date().getFullYear()} | Hansis IT Supervision Pvt Ltd. All
          Rights Reserved
        </p>
      </div>{" "}
    </div>
  );
};

export default Associate;
